<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      custom-class="dialog_normalsuo dialog_normalsuo_update"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center margin-bottom10">
            <img
              class="imgDeng"
              src="../../../assets/dialogIcoImg/updateIcon.png"
              alt=""
            />
          </div>
          <h3>{{ $t("ListofResults.Update") }}</h3>
          <div class="detail_cont_text" style="padding: 0px">
            {{ $t("ListofResults.Iftheavailable") }}
            <br />
            <br />
            {{ $t("ListofResults.Abusinesscredit") }}
          </div>
        </div>
      </div>
      <div class="flex_center margin-top30 DialogBtnBox">
        <el-button
          class="btn_export btn_exportCCC"
          @click="onSubmitkoudian()"
          >{{ $t("ListofResults.Update") }}</el-button
        >
        <el-button
          v-if="$store.state.app.equityType < PointDetail"
          class="btn_export"
          style="margin: 0"
          @click="onSubmitquxiao()"
          >{{ $t("navigationBar.AddCredits") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveUserConsumption, getPointAndHour } from "@/api/userApi";

export default {
  props: {
    suoClose: {
      type: Boolean,
    },
    obj: {
      type: Object,
    },
    update: {
      type: Object,
    },
    ComapnyName: {
      type: String,
    },
  },
  data() {
    return {
      PointDetail: 0,
      token: sessionStorage.getItem("token"),
    };
  },
  computed: {
    newDialog: {
      get() {
        if (this.suoClose) {
          this.getgetPointAndHour();
        }
        return this.suoClose;
      },
      set() {},
    },
  },
  destroyed() {},
  mounted() {},
  methods: {
    getgetPointAndHour() {
      getPointAndHour([
        {
          companyAaaid: this.$route.query.id3a,
          countryCode: this.$route.query.companyCountry,
          companyName: this.ComapnyName,
        },
      ]).then((res) => {
        if (res.code == 200) {
          this.PointDetail = res.data.point;
        }
      });
    },
    //关闭弹窗
    closeDialog() {
      this.$emit("closeCloseDialog", false);
    },
    onSubmitkoudian() {
      this.newDialog = false;
      this.$emit("closeCloseDialog", false);
      const base = JSON.parse(localStorage.getItem("CompanyBase"));

      saveUserConsumption({
        companyAaaid: this.$route.query.id3a,
        countryCode: base.base.countryFlag,
        companyName: this.ComapnyName,
      }).then((res) => {
        if (res.code == 200) {
          this.$parent.toolsConfig.update.isActive = false;
          this.$router.go(0);
          this.$parent.UpdateStatus = 3;
          this.$message({
            message: "Available Credits: -" + res.data.consumptionPoints,
            type: "success",
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onSubmitquxiao() {
      this.$router.push({
        path: "/index/addCredit",
      });
      let that = this;
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
    },
  },
};
</script>
<style scoped>
.detail_cont {
  max-height: 68%;
  overflow: auto;
}
.btn_export {
  width: 180px;
  height: 48px;
  border-radius: 10px;
  font-size: 16px;
  line-height: 18px;
  padding: 0;
}
.DialogBtnBox {
  gap: 30px;
}
.imgDeng {
  width: 60px;
  height: 52px;
}
@media (max-width: 1920px) {
  .btn_export {
    width: 136px;
    height: 36px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 18px;
  }
  .DialogBtnBox {
    gap: 22px;
  }
  .imgDeng {
    width: 45px;
    height: 40px;
  }
}
@media (max-width: 1439px) {
  .btn_export {
    width: 120px;
    height: 32px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 14px;
  }
  .DialogBtnBox {
    gap: 20px;
  }
  .imgDeng {
    width: 40px;
    height: 35px;
  }
}
</style>
